"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _reactFeather = require("react-feather");

var _Elements = require("../../Elements");

var _Flex = _interopRequireDefault(require("../../Layout/Flex"));

var Styled = _interopRequireWildcard(require("./LeavingDialog.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LeavingDialog = function LeavingDialog(_a) {
  var href = _a.href,
      body = _a.body,
      bodyContinue = _a.bodyContinue,
      cancelText = _a.cancelText,
      continueText = _a.continueText,
      props = (0, _tslib.__rest)(_a, ["href", "body", "bodyContinue", "cancelText", "continueText"]);
  return _react.default.createElement(Styled.LeavingModal, (0, _tslib.__assign)({
    closeIcon: _react.default.createElement(_reactFeather.X, null),
    largeTitle: true
  }, props), _react.default.createElement(Styled.Hr, null), _react.default.createElement(_Flex.default, {
    flexDirection: "column",
    justifyContent: "center",
    px: [0, 8]
  }, _react.default.createElement(Styled.BodyBox, null, body), _react.default.createElement(Styled.ContinueBox, null, bodyContinue)), _react.default.createElement(_Flex.default, {
    alignItems: "center",
    flexDirection: ['column-reverse', 'row'],
    justifyContent: ['flex-start', 'center'],
    pb: [0, '36px']
  }, _react.default.createElement(Styled.NoThanks, {
    "aria-label": "Close",
    as: "button",
    "data-testid": "leavingDialogue__cancel",
    onClick: function onClick() {
      return props.onClose();
    }
  }, cancelText), _react.default.createElement(Styled.Continue, {
    as: _Elements.Anchor,
    "data-testid": "leavingDialogue__continue",
    href: href
  }, continueText)));
};

LeavingDialog.defaultProps = {
  body: 'Are you sure you want to leave this site?',
  bodyContinue: 'Would you like to continue?',
  cancelText: 'No, thanks',
  closeTitle: 'Close Dialog',
  continueText: 'Continue',
  title: 'You\'re now leaving this site'
};
var _default = LeavingDialog;
exports.default = _default;